// Pre-generated narration clips (ElevenLabs "Candy – Young and Sweet") for the
// read-aloud hints, served over jsDelivr from the public cquidet-pro/learn-draw-audio
// repo (zero Firebase egress). The player plays the matching clip for a step's
// spoken hint and falls back to the browser voice for anything without a clip.
//
// THIS FILE IS GENERATED from the clips present in the audio repo — do not edit by
// hand; add clips to the repo and regenerate (gen-manifest.mjs).
//
// Language: nl. Layout: nl/common/<slug>.mp3 (lines shared by many
// drawings) and nl/<drawing-id>/<slug>.mp3 (a drawing's own hints). A
// drawing-specific clip wins over the shared/common one.
import { clipSlug } from "./clipSlug";

const AUDIO_BASE = "https://cdn.jsdelivr.net/gh/cquidet-pro/learn-draw-audio@1901598ca370316d6340d2794d8f6e09f9843367/nl";

// Lines shared by many drawings: slug → path within the audio repo.
const COMMON: Record<string, string> = {
  "begin-met-de-pony-s-lichaam": "common/begin-met-de-pony-s-lichaam.mp3",
  "begin-met-de-ronde-hoofd": "common/begin-met-de-ronde-hoofd.mp3",
  "begin-met-een-groot-afgerond-lichaam": "common/begin-met-een-groot-afgerond-lichaam.mp3",
  "begin-met-een-grote-ronde-hoofd": "common/begin-met-een-grote-ronde-hoofd.mp3",
  "begin-met-een-grote-rounded-lichaam": "common/begin-met-een-grote-rounded-lichaam.mp3",
  "begin-met-een-rode-boog": "common/begin-met-een-rode-boog.mp3",
  "bijna-klaar": "common/bijna-klaar.mp3",
  "boterig-geel-voor-de-hoorn": "common/boterig-geel-voor-de-hoorn.mp3",
  "brew-een-storm-wolk-op-de-right": "common/brew-een-storm-wolk-op-de-right.mp3",
  "buttery-gele-for-de-hoorn": "common/buttery-gele-for-de-hoorn.mp3",
  "daarna-indigo": "common/daarna-indigo.mp3",
  "dan-blauw": "common/dan-blauw.mp3",
  "dan-geel": "common/dan-geel.mp3",
  "dan-groen": "common/dan-groen.mp3",
  "de-kleinste-boog": "common/de-kleinste-boog.mp3",
  "dit-is-een-achthoek-teken-8-rechte-zijden": "common/dit-is-een-achthoek-teken-8-rechte-zijden.mp3",
  "dit-is-een-cirkel-teken-een-grote-ronde-cirkel": "common/dit-is-een-cirkel-teken-een-grote-ronde-cirkel.mp3",
  "dit-is-een-driehoek-teken-3-rechte-zijden": "common/dit-is-een-driehoek-teken-3-rechte-zijden.mp3",
  "dit-is-een-halve-maan-de-gebogen-vorm-van-de-maan": "common/dit-is-een-halve-maan-de-gebogen-vorm-van-de-maan.mp3",
  "dit-is-een-hart-teken-twee-bobbels-en-een-punt": "common/dit-is-een-hart-teken-twee-bobbels-en-een-punt.mp3",
  "dit-is-een-ovaal-als-een-cirkel-maar-uitgerekt": "common/dit-is-een-ovaal-als-een-cirkel-maar-uitgerekt.mp3",
  "dit-is-een-parallellogram-een-rechthoek-die-scheef-staat": "common/dit-is-een-parallellogram-een-rechthoek-die-scheef-staat.mp3",
  "dit-is-een-rechthoek-2-lange-zijden-en-2-korte-zijden": "common/dit-is-een-rechthoek-2-lange-zijden-en-2-korte-zijden.mp3",
  "dit-is-een-ruit-een-vierkant-dat-op-zijn-punt-staat": "common/dit-is-een-ruit-een-vierkant-dat-op-zijn-punt-staat.mp3",
  "dit-is-een-ster-teken-5-puntige-punten": "common/dit-is-een-ster-teken-5-puntige-punten.mp3",
  "dit-is-een-trapezium-smal-boven-breed-onderaan": "common/dit-is-een-trapezium-smal-boven-breed-onderaan.mp3",
  "dit-is-een-vierkant-teken-4-zijden-die-allemaal-even-lang-zijn": "common/dit-is-een-vierkant-teken-4-zijden-die-allemaal-even-lang-zijn.mp3",
  "dit-is-een-vijfhoek-teken-5-rechte-zijden": "common/dit-is-een-vijfhoek-teken-5-rechte-zijden.mp3",
  "dit-is-een-zeshoek-teken-6-rechte-zijden": "common/dit-is-een-zeshoek-teken-6-rechte-zijden.mp3",
  "eindig-met-bellen": "common/eindig-met-bellen.mp3",
  "eindig-met-birds-flying-by": "common/eindig-met-birds-flying-by.mp3",
  "eindig-met-cubist-lijnen": "common/eindig-met-cubist-lijnen.mp3",
  "eindig-met-de-grond-en-een-bot": "common/eindig-met-de-grond-en-een-bot.mp3",
  "eindig-met-de-grond-en-een-varen": "common/eindig-met-de-grond-en-een-varen.mp3",
  "eindig-met-de-ground-en-een-bone": "common/eindig-met-de-ground-en-een-bone.mp3",
  "eindig-met-de-ground-en-een-fern": "common/eindig-met-de-ground-en-een-fern.mp3",
  "eindig-met-de-hoge-cipres": "common/eindig-met-de-hoge-cipres.mp3",
  "eindig-met-de-hoge-cypress-boom": "common/eindig-met-de-hoge-cypress-boom.mp3",
  "eindig-met-de-road": "common/eindig-met-de-road.mp3",
  "eindig-met-de-weg": "common/eindig-met-de-weg.mp3",
  "eindig-met-de-zon": "common/eindig-met-de-zon.mp3",
  "eindig-met-een-appel-op-zijn-back": "common/eindig-met-een-appel-op-zijn-back.mp3",
  "eindig-met-een-appel-op-zijn-rug": "common/eindig-met-een-appel-op-zijn-rug.mp3",
  "eindig-met-een-ball-of-yarn-to-play-met": "common/eindig-met-een-ball-of-yarn-to-play-met.mp3",
  "eindig-met-een-blije-glimlach": "common/eindig-met-een-blije-glimlach.mp3",
  "eindig-met-een-blije-smile": "common/eindig-met-een-blije-smile.mp3",
  "eindig-met-een-bliksem-emblem-in-een-schild": "common/eindig-met-een-bliksem-emblem-in-een-schild.mp3",
  "eindig-met-een-bliksem-emblem-op-de-chest": "common/eindig-met-een-bliksem-emblem-op-de-chest.mp3",
  "eindig-met-een-bliksemembleem-in-een-schild": "common/eindig-met-een-bliksemembleem-in-een-schild.mp3",
  "eindig-met-een-bliksemembleem-op-de-borst": "common/eindig-met-een-bliksemembleem-op-de-borst.mp3",
  "eindig-met-een-bloem-en-gras": "common/eindig-met-een-bloem-en-gras.mp3",
  "eindig-met-een-bol-wol-om-mee-te-spelen": "common/eindig-met-een-bol-wol-om-mee-te-spelen.mp3",
  "eindig-met-een-donzige-wolk": "common/eindig-met-een-donzige-wolk.mp3",
  "eindig-met-een-felle-zon": "common/eindig-met-een-felle-zon.mp3",
  "eindig-met-een-fluffy-wolk": "common/eindig-met-een-fluffy-wolk.mp3",
  "eindig-met-een-fonkelende-ster": "common/eindig-met-een-fonkelende-ster.mp3",
  "eindig-met-een-krullende-staart": "common/eindig-met-een-krullende-staart.mp3",
  "eindig-met-een-kwispelende-staart": "common/eindig-met-een-kwispelende-staart.mp3",
  "eindig-met-een-oog-en-een-glimlach": "common/eindig-met-een-oog-en-een-glimlach.mp3",
  "eindig-met-een-oog-en-een-smile": "common/eindig-met-een-oog-en-een-smile.mp3",
  "eindig-met-een-oog-en-stippen": "common/eindig-met-een-oog-en-stippen.mp3",
  "eindig-met-een-rij-of-bloemen-onder": "common/eindig-met-een-rij-of-bloemen-onder.mp3",
  "eindig-met-een-shining-zon": "common/eindig-met-een-shining-zon.mp3",
  "eindig-met-een-sparkly-ster": "common/eindig-met-een-sparkly-ster.mp3",
  "eindig-met-een-spetterende-plas": "common/eindig-met-een-spetterende-plas.mp3",
  "eindig-met-een-splashy-puddle": "common/eindig-met-een-splashy-puddle.mp3",
  "eindig-met-een-stralende-zon": "common/eindig-met-een-stralende-zon.mp3",
  "eindig-met-een-sunny-sky": "common/eindig-met-een-sunny-sky.mp3",
  "eindig-met-een-vriendelijke-oog": "common/eindig-met-een-vriendelijke-oog.mp3",
  "eindig-met-een-wagging-staart": "common/eindig-met-een-wagging-staart.mp3",
  "eindig-met-een-zon-en-birds": "common/eindig-met-een-zon-en-birds.mp3",
  "eindig-met-een-zon-en-een-pad": "common/eindig-met-een-zon-en-een-pad.mp3",
  "eindig-met-een-zon-en-een-path": "common/eindig-met-een-zon-en-een-path.mp3",
  "eindig-met-een-zon-en-vogels": "common/eindig-met-een-zon-en-vogels.mp3",
  "eindig-met-een-zonnige-lucht": "common/eindig-met-een-zonnige-lucht.mp3",
  "eindig-met-gras-at-de-bottom": "common/eindig-met-gras-at-de-bottom.mp3",
  "eindig-met-gras-onderaan": "common/eindig-met-gras-onderaan.mp3",
  "eindig-met-kleine-boats-riding-de-zee": "common/eindig-met-kleine-boats-riding-de-zee.mp3",
  "eindig-met-kleine-bootjes-die-op-de-zee-varen": "common/eindig-met-kleine-bootjes-die-op-de-zee-varen.mp3",
  "eindig-met-kleine-hearts-floating-up": "common/eindig-met-kleine-hearts-floating-up.mp3",
  "eindig-met-kleine-hoeven-en-een-zwierige-staart": "common/eindig-met-kleine-hoeven-en-een-zwierige-staart.mp3",
  "eindig-met-kleine-hooves-en-een-swishy-staart": "common/eindig-met-kleine-hooves-en-een-swishy-staart.mp3",
  "eindig-met-kleine-zwevende-hartjes": "common/eindig-met-kleine-zwevende-hartjes.mp3",
  "eindig-met-krullerige-vleugelpatronen": "common/eindig-met-krullerige-vleugelpatronen.mp3",
  "eindig-met-kubistische-lijnen": "common/eindig-met-kubistische-lijnen.mp3",
  "eindig-met-musical-notes": "common/eindig-met-musical-notes.mp3",
  "eindig-met-musical-notes-en-een-ster": "common/eindig-met-musical-notes-en-een-ster.mp3",
  "eindig-met-muzieknoten": "common/eindig-met-muzieknoten.mp3",
  "eindig-met-muzieknoten-en-een-ster": "common/eindig-met-muzieknoten-en-een-ster.mp3",
  "eindig-met-snorharen-en-een-glimlach": "common/eindig-met-snorharen-en-een-glimlach.mp3",
  "eindig-met-swirly-vleugel-patterns": "common/eindig-met-swirly-vleugel-patterns.mp3",
  "eindig-met-twee-kleine-hartjes": "common/eindig-met-twee-kleine-hartjes.mp3",
  "eindig-met-two-kleine-hearts": "common/eindig-met-two-kleine-hearts.mp3",
  "eindig-met-vogels-die-voorbij-vliegen": "common/eindig-met-vogels-die-voorbij-vliegen.mp3",
  "eindig-met-wild-haar-en-een-oor": "common/eindig-met-wild-haar-en-een-oor.mp3",
  "eindig-met-wild-hair-en-an-oor": "common/eindig-met-wild-hair-en-an-oor.mp3",
  "en-dat-ben-jij-klein": "common/en-dat-ben-jij-klein.mp3",
  "en-eentje-rechts": "common/en-eentje-rechts.mp3",
  "en-one-op-de-right": "common/en-one-op-de-right.mp3",
  "en-that-s-kleine-you": "common/en-that-s-kleine-you.mp3",
  "flow-de-golvende-manen-down-de-nek": "common/flow-de-golvende-manen-down-de-nek.mp3",
  "ga-door": "common/ga-door.mp3",
  "geef-de-cijfer-zijn-3-d-edge": "common/geef-de-cijfer-zijn-3-d-edge.mp3",
  "geef-de-pony-een-saddle": "common/geef-de-pony-een-saddle.mp3",
  "geef-de-pony-een-zadel": "common/geef-de-pony-een-zadel.mp3",
  "geef-de-zon-een-blij-gezichtje": "common/geef-de-zon-een-blij-gezichtje.mp3",
  "geef-de-zon-een-blije-face": "common/geef-de-zon-een-blije-face.mp3",
  "geef-haar-een-blije-glimlach": "common/geef-haar-een-blije-glimlach.mp3",
  "geef-het-an-oog-en-een-neus": "common/geef-het-an-oog-en-een-neus.mp3",
  "geef-het-cijfer-een-3-d-rand": "common/geef-het-cijfer-een-3-d-rand.mp3",
  "geef-het-een-blij-gezicht": "common/geef-het-een-blij-gezicht.mp3",
  "geef-het-een-cute-neus": "common/geef-het-een-cute-neus.mp3",
  "geef-het-een-schattig-neusje": "common/geef-het-een-schattig-neusje.mp3",
  "geef-het-four-chunky-benen-en-feet": "common/geef-het-four-chunky-benen-en-feet.mp3",
  "geef-het-nu-kleur": "common/geef-het-nu-kleur.mp3",
  "geef-het-vier-dikke-poten-en-voetjes": "common/geef-het-vier-dikke-poten-en-voetjes.mp3",
  "groene-next": "common/groene-next.mp3",
  "hang-een-kleine-schommel-aan-een-tak": "common/hang-een-kleine-schommel-aan-een-tak.mp3",
  "hang-een-kleine-swing-van-een-tak": "common/hang-een-kleine-swing-van-een-tak.mp3",
  "jee-helemaal-klaar-druk-op-voor-een-verrassing": "common/jee-helemaal-klaar-druk-op-voor-een-verrassing.mp3",
  "klaar-laten-we-het-nog-een-keer-bekijken": "common/klaar-laten-we-het-nog-een-keer-bekijken.mp3",
  "kleur-de-rode-trim-first": "common/kleur-de-rode-trim-first.mp3",
  "kleur-eerst-de-rode-bies": "common/kleur-eerst-de-rode-bies.mp3",
  "kleur-haar-nu-helemaal-in": "common/kleur-haar-nu-helemaal-in.mp3",
  "kleur-hem-nu-helemaal-in": "common/kleur-hem-nu-helemaal-in.mp3",
  "kleur-het-nu-helemaal-in": "common/kleur-het-nu-helemaal-in.mp3",
  "kleur-het-nu-in": "common/kleur-het-nu-in.mp3",
  "kleur-het-shirt-nu-blauw": "common/kleur-het-shirt-nu-blauw.mp3",
  "kleur-nu-de-beer-in": "common/kleur-nu-de-beer-in.mp3",
  "kleur-nu-de-eend-in": "common/kleur-nu-de-eend-in.mp3",
  "kleur-nu-de-hamster-in": "common/kleur-nu-de-hamster-in.mp3",
  "kleur-nu-de-hele-lucht-in": "common/kleur-nu-de-hele-lucht-in.mp3",
  "kleur-nu-de-hele-regenboog-in": "common/kleur-nu-de-hele-regenboog-in.mp3",
  "kleur-nu-de-kikker-in": "common/kleur-nu-de-kikker-in.mp3",
  "kleur-nu-de-koe-in": "common/kleur-nu-de-koe-in.mp3",
  "kleur-nu-de-leeuw-in": "common/kleur-nu-de-leeuw-in.mp3",
  "kleur-nu-de-muis-in": "common/kleur-nu-de-muis-in.mp3",
  "kleur-nu-de-olifant-in": "common/kleur-nu-de-olifant-in.mp3",
  "kleur-nu-de-pinguin-in": "common/kleur-nu-de-pinguin-in.mp3",
  "kleur-nu-de-shirt-blauwe": "common/kleur-nu-de-shirt-blauwe.mp3",
  "kleur-nu-de-vis-in": "common/kleur-nu-de-vis-in.mp3",
  "kleur-nu-de-vlag-in": "common/kleur-nu-de-vlag-in.mp3",
  "kleur-nu-de-vos-in": "common/kleur-nu-de-vos-in.mp3",
  "kleur-nu-de-walvis-in": "common/kleur-nu-de-walvis-in.mp3",
  "kleur-nu-de-whole-regenboog-in": "common/kleur-nu-de-whole-regenboog-in.mp3",
  "kleur-nu-de-whole-sky-in": "common/kleur-nu-de-whole-sky-in.mp3",
  "kleur-nu-de-wolk-in": "common/kleur-nu-de-wolk-in.mp3",
  "kleur-nu-her-all-in": "common/kleur-nu-her-all-in.mp3",
  "kleur-nu-het-konijn-in": "common/kleur-nu-het-konijn-in.mp3",
  "kleur-nu-het-paard-in": "common/kleur-nu-het-paard-in.mp3",
  "kleur-nu-het-varken-in": "common/kleur-nu-het-varken-in.mp3",
  "kleur-nu-him-all-in": "common/kleur-nu-him-all-in.mp3",
  "kleur-nu-it-in": "common/kleur-nu-it-in.mp3",
  "kleur-nu-je-achthoek-in": "common/kleur-nu-je-achthoek-in.mp3",
  "kleur-nu-je-cirkel-in": "common/kleur-nu-je-cirkel-in.mp3",
  "kleur-nu-je-driehoek-in": "common/kleur-nu-je-driehoek-in.mp3",
  "kleur-nu-je-eenhoorn-in": "common/kleur-nu-je-eenhoorn-in.mp3",
  "kleur-nu-je-gezin-in": "common/kleur-nu-je-gezin-in.mp3",
  "kleur-nu-je-gezinscene-in": "common/kleur-nu-je-gezinscene-in.mp3",
  "kleur-nu-je-halve-maan-in": "common/kleur-nu-je-halve-maan-in.mp3",
  "kleur-nu-je-hart-in": "common/kleur-nu-je-hart-in.mp3",
  "kleur-nu-je-ijsje-in": "common/kleur-nu-je-ijsje-in.mp3",
  "kleur-nu-je-ovaal-in": "common/kleur-nu-je-ovaal-in.mp3",
  "kleur-nu-je-parallellogram-in": "common/kleur-nu-je-parallellogram-in.mp3",
  "kleur-nu-je-rechthoek-in": "common/kleur-nu-je-rechthoek-in.mp3",
  "kleur-nu-je-ruit-in": "common/kleur-nu-je-ruit-in.mp3",
  "kleur-nu-je-slak-in": "common/kleur-nu-je-slak-in.mp3",
  "kleur-nu-je-ster-in": "common/kleur-nu-je-ster-in.mp3",
  "kleur-nu-je-trapezium-in": "common/kleur-nu-je-trapezium-in.mp3",
  "kleur-nu-je-vierkant-in": "common/kleur-nu-je-vierkant-in.mp3",
  "kleur-nu-je-vijfhoek-in": "common/kleur-nu-je-vijfhoek-in.mp3",
  "kleur-nu-je-zeshoek-in": "common/kleur-nu-je-zeshoek-in.mp3",
  "laat-de-golvende-manen-langs-de-nek-vloeien": "common/laat-de-golvende-manen-langs-de-nek-vloeien.mp3",
  "maak-de-arcs-met-violet": "common/maak-de-arcs-met-violet.mp3",
  "maak-de-bogen-af-met-violet": "common/maak-de-bogen-af-met-violet.mp3",
  "maak-een-kleine-vlag-vak-in-de-hoek": "common/maak-een-kleine-vlag-vak-in-de-hoek.mp3",
  "maak-een-sunny-meadow-met-gras": "common/maak-een-sunny-meadow-met-gras.mp3",
  "maak-een-zonnig-weiland-met-gras": "common/maak-een-zonnig-weiland-met-gras.mp3",
  "nog-een": "common/nog-een.mp3",
  "nog-een-boog-just-binnenin": "common/nog-een-boog-just-binnenin.mp3",
  "nog-een-boog-net-erbinnen": "common/nog-een-boog-net-erbinnen.mp3",
  "nu-bring-it-to-life-met-color": "common/nu-bring-it-to-life-met-color.mp3",
  "nu-creamy-peach-swirls": "common/nu-creamy-peach-swirls.mp3",
  "nu-de-volgende-kleur": "common/nu-de-volgende-kleur.mp3",
  "nu-lila-krullen": "common/nu-lila-krullen.mp3",
  "nu-oranje": "common/nu-oranje.mp3",
  "nu-romige-perzikkrullen": "common/nu-romige-perzikkrullen.mp3",
  "nu-spiegel-it-op-de-right": "common/nu-spiegel-it-op-de-right.mp3",
  "nu-twee-fonkelende-ogen": "common/nu-twee-fonkelende-ogen.mp3",
  "nu-two-sparkly-ogen": "common/nu-two-sparkly-ogen.mp3",
  "plant-een-boom-beside-de-house": "common/plant-een-boom-beside-de-house.mp3",
  "plant-een-boom-naast-het-huis": "common/plant-een-boom-naast-het-huis.mp3",
  "put-de-ster-op-een-stage-met-een-spotlight": "common/put-de-ster-op-een-stage-met-een-spotlight.mp3",
  "roze-for-de-manen": "common/roze-for-de-manen.mp3",
  "roze-voor-de-manen": "common/roze-voor-de-manen.mp3",
  "schiet-een-pijl-door-het": "common/schiet-een-pijl-door-het.mp3",
  "schrijf-a-c-h-t-h-o-e-k": "common/schrijf-a-c-h-t-h-o-e-k.mp3",
  "schrijf-a-l-g-e-r-i-j-e": "common/schrijf-a-l-g-e-r-i-j-e.mp3",
  "schrijf-a-r-g-e-n-t-i-n-i-e": "common/schrijf-a-r-g-e-n-t-i-n-i-e.mp3",
  "schrijf-a-u-s-t-r-a-l-i-e": "common/schrijf-a-u-s-t-r-a-l-i-e.mp3",
  "schrijf-a-u-t-o": "common/schrijf-a-u-t-o.mp3",
  "schrijf-b-e-l-g-i-e": "common/schrijf-b-e-l-g-i-e.mp3",
  "schrijf-b-l-o-e-m": "common/schrijf-b-l-o-e-m.mp3",
  "schrijf-b-o-o-m": "common/schrijf-b-o-o-m.mp3",
  "schrijf-b-o-s-n-i-e-e-n-h-e-r-z-e-g-o-v-i-n-a": "common/schrijf-b-o-s-n-i-e-e-n-h-e-r-z-e-g-o-v-i-n-a.mp3",
  "schrijf-b-r-a-z-i-l-i-e": "common/schrijf-b-r-a-z-i-l-i-e.mp3",
  "schrijf-c-a-n-a-d-a": "common/schrijf-c-a-n-a-d-a.mp3",
  "schrijf-c-h-i-n-a": "common/schrijf-c-h-i-n-a.mp3",
  "schrijf-c-i-r-k-e-l": "common/schrijf-c-i-r-k-e-l.mp3",
  "schrijf-c-o-l-o-m-b-i-a": "common/schrijf-c-o-l-o-m-b-i-a.mp3",
  "schrijf-c-o-n-g-o-k-i-n-s-h-a-s-a": "common/schrijf-c-o-n-g-o-k-i-n-s-h-a-s-a.mp3",
  "schrijf-c-u-r-a-c-a-o": "common/schrijf-c-u-r-a-c-a-o.mp3",
  "schrijf-d-e-n-e-m-a-r-k-e-n": "common/schrijf-d-e-n-e-m-a-r-k-e-n.mp3",
  "schrijf-d-i-n-o-s-a-u-r-u-s": "common/schrijf-d-i-n-o-s-a-u-r-u-s.mp3",
  "schrijf-d-r-i-e-h-o-e-k": "common/schrijf-d-r-i-e-h-o-e-k.mp3",
  "schrijf-d-u-i-t-s-l-a-n-d": "common/schrijf-d-u-i-t-s-l-a-n-d.mp3",
  "schrijf-de-naam-van-de-speler-mbappe": "common/schrijf-de-naam-van-de-speler-mbappe.mp3",
  "schrijf-de-woorden-ordem-e-progresso-order-and-progress": "common/schrijf-de-woorden-ordem-e-progresso-order-and-progress.mp3",
  "schrijf-drie-kleine-groene-streepjes": "common/schrijf-drie-kleine-groene-streepjes.mp3",
  "schrijf-e-c-u-a-d-o-r": "common/schrijf-e-c-u-a-d-o-r.mp3",
  "schrijf-e-e-n-h-o-o-r-n": "common/schrijf-e-e-n-h-o-o-r-n.mp3",
  "schrijf-e-g-e-l": "common/schrijf-e-g-e-l.mp3",
  "schrijf-e-g-y-p-t-e": "common/schrijf-e-g-y-p-t-e.mp3",
  "schrijf-e-n-g-e-l-a-n-d": "common/schrijf-e-n-g-e-l-a-n-d.mp3",
  "schrijf-f-i-n-l-a-n-d": "common/schrijf-f-i-n-l-a-n-d.mp3",
  "schrijf-f-r-a-n-k-r-i-j-k": "common/schrijf-f-r-a-n-k-r-i-j-k.mp3",
  "schrijf-g-e-z-i-n": "common/schrijf-g-e-z-i-n.mp3",
  "schrijf-g-h-a-n-a": "common/schrijf-g-h-a-n-a.mp3",
  "schrijf-g-r-i-e-k-e-n-l-a-n-d": "common/schrijf-g-r-i-e-k-e-n-l-a-n-d.mp3",
  "schrijf-h-a-i-t-i": "common/schrijf-h-a-i-t-i.mp3",
  "schrijf-h-a-r-t": "common/schrijf-h-a-r-t.mp3",
  "schrijf-h-o-n-d": "common/schrijf-h-o-n-d.mp3",
  "schrijf-h-u-i-s": "common/schrijf-h-u-i-s.mp3",
  "schrijf-i-e-r-l-a-n-d": "common/schrijf-i-e-r-l-a-n-d.mp3",
  "schrijf-i-j-s-j-e": "common/schrijf-i-j-s-j-e.mp3",
  "schrijf-i-n-d-i-a": "common/schrijf-i-n-d-i-a.mp3",
  "schrijf-i-r-a-k": "common/schrijf-i-r-a-k.mp3",
  "schrijf-i-r-a-n": "common/schrijf-i-r-a-n.mp3",
  "schrijf-i-t-a-l-i-e": "common/schrijf-i-t-a-l-i-e.mp3",
  "schrijf-i-v-o-o-r-k-u-s-t": "common/schrijf-i-v-o-o-r-k-u-s-t.mp3",
  "schrijf-j-a-p-a-n": "common/schrijf-j-a-p-a-n.mp3",
  "schrijf-j-o-r-d-a-n-i-e": "common/schrijf-j-o-r-d-a-n-i-e.mp3",
  "schrijf-k-a-a-p-v-e-r-d-i-e": "common/schrijf-k-a-a-p-v-e-r-d-i-e.mp3",
  "schrijf-k-a-t": "common/schrijf-k-a-t.mp3",
  "schrijf-k-r-o-a-t-i-e": "common/schrijf-k-r-o-a-t-i-e.mp3",
  "schrijf-m-a-a-n": "common/schrijf-m-a-a-n.mp3",
  "schrijf-m-a-r-o-k-k-o": "common/schrijf-m-a-r-o-k-k-o.mp3",
  "schrijf-m-e-x-i-c-o": "common/schrijf-m-e-x-i-c-o.mp3",
  "schrijf-n-e-d-e-r-l-a-n-d": "common/schrijf-n-e-d-e-r-l-a-n-d.mp3",
  "schrijf-n-i-e-u-w-z-e-e-l-a-n-d": "common/schrijf-n-i-e-u-w-z-e-e-l-a-n-d.mp3",
  "schrijf-n-o-o-r-w-e-g-e-n": "common/schrijf-n-o-o-r-w-e-g-e-n.mp3",
  "schrijf-o-e-z-b-e-k-i-s-t-a-n": "common/schrijf-o-e-z-b-e-k-i-s-t-a-n.mp3",
  "schrijf-o-o-s-t-e-n-r-i-j-k": "common/schrijf-o-o-s-t-e-n-r-i-j-k.mp3",
  "schrijf-o-v-a-a-l": "common/schrijf-o-v-a-a-l.mp3",
  "schrijf-p-a-a-r-d": "common/schrijf-p-a-a-r-d.mp3",
  "schrijf-p-a-n-a-m-a": "common/schrijf-p-a-n-a-m-a.mp3",
  "schrijf-p-a-r-a-g-u-a-y": "common/schrijf-p-a-r-a-g-u-a-y.mp3",
  "schrijf-p-a-r-a-l-l-e-l-l-o-g-r-a-m": "common/schrijf-p-a-r-a-l-l-e-l-l-o-g-r-a-m.mp3",
  "schrijf-p-o-p-s-t-e-r": "common/schrijf-p-o-p-s-t-e-r.mp3",
  "schrijf-p-o-r-t-u-g-a-l": "common/schrijf-p-o-r-t-u-g-a-l.mp3",
  "schrijf-p-r-i-n-s-e-s": "common/schrijf-p-r-i-n-s-e-s.mp3",
  "schrijf-q-a-t-a-r": "common/schrijf-q-a-t-a-r.mp3",
  "schrijf-r-e-c-h-t-h-o-e-k": "common/schrijf-r-e-c-h-t-h-o-e-k.mp3",
  "schrijf-r-e-g-e-n-b-o-o-g": "common/schrijf-r-e-g-e-n-b-o-o-g.mp3",
  "schrijf-r-u-i-t": "common/schrijf-r-u-i-t.mp3",
  "schrijf-s-a-o-e-d-i-a-r-a-b-i-e": "common/schrijf-s-a-o-e-d-i-a-r-a-b-i-e.mp3",
  "schrijf-s-c-h-o-t-l-a-n-d": "common/schrijf-s-c-h-o-t-l-a-n-d.mp3",
  "schrijf-s-e-n-e-g-a-l": "common/schrijf-s-e-n-e-g-a-l.mp3",
  "schrijf-s-i-n-g-a-p-o-r-e": "common/schrijf-s-i-n-g-a-p-o-r-e.mp3",
  "schrijf-s-l-a-k": "common/schrijf-s-l-a-k.mp3",
  "schrijf-s-p-a-n-j-e": "common/schrijf-s-p-a-n-j-e.mp3",
  "schrijf-s-t-e-r": "common/schrijf-s-t-e-r.mp3",
  "schrijf-s-u-p-e-r-s-t-o-r-m-y": "common/schrijf-s-u-p-e-r-s-t-o-r-m-y.mp3",
  "schrijf-t-r-a-p-e-z-i-u-m": "common/schrijf-t-r-a-p-e-z-i-u-m.mp3",
  "schrijf-t-s-j-e-c-h-i-e": "common/schrijf-t-s-j-e-c-h-i-e.mp3",
  "schrijf-t-u-n-e-s-i-e": "common/schrijf-t-u-n-e-s-i-e.mp3",
  "schrijf-t-u-r-k-i-j-e": "common/schrijf-t-u-r-k-i-j-e.mp3",
  "schrijf-u-r-u-g-u-a-y": "common/schrijf-u-r-u-g-u-a-y.mp3",
  "schrijf-v-e-r-e-n-i-g-d-e-a-r-a-b-i-s-c-h-e-e-m-i-r-a-t-e-n": "common/schrijf-v-e-r-e-n-i-g-d-e-a-r-a-b-i-s-c-h-e-e-m-i-r-a-t-e-n.mp3",
  "schrijf-v-e-r-e-n-i-g-d-e-s-t-a-t-e-n": "common/schrijf-v-e-r-e-n-i-g-d-e-s-t-a-t-e-n.mp3",
  "schrijf-v-e-r-e-n-i-g-d-k-o-n-i-n-k-r-i-j-k": "common/schrijf-v-e-r-e-n-i-g-d-k-o-n-i-n-k-r-i-j-k.mp3",
  "schrijf-v-i-e-r-k-a-n-t": "common/schrijf-v-i-e-r-k-a-n-t.mp3",
  "schrijf-v-i-j-f-h-o-e-k": "common/schrijf-v-i-j-f-h-o-e-k.mp3",
  "schrijf-v-i-s": "common/schrijf-v-i-s.mp3",
  "schrijf-v-l-i-n-d-e-r": "common/schrijf-v-l-i-n-d-e-r.mp3",
  "schrijf-w-o-l-k": "common/schrijf-w-o-l-k.mp3",
  "schrijf-wat-witte-streepjes-overdwars": "common/schrijf-wat-witte-streepjes-overdwars.mp3",
  "schrijf-z-e-s-h-o-e-k": "common/schrijf-z-e-s-h-o-e-k.mp3",
  "schrijf-z-o-n": "common/schrijf-z-o-n.mp3",
  "schrijf-z-u-i-d-a-f-r-i-k-a": "common/schrijf-z-u-i-d-a-f-r-i-k-a.mp3",
  "schrijf-z-u-i-d-k-o-r-e-a": "common/schrijf-z-u-i-d-k-o-r-e-a.mp3",
  "schrijf-z-w-e-d-e-n": "common/schrijf-z-w-e-d-e-n.mp3",
  "schrijf-z-w-i-t-s-e-r-l-a-n-d": "common/schrijf-z-w-i-t-s-e-r-l-a-n-d.mp3",
  "spiegel-het-nu-aan-de-rechterkant": "common/spiegel-het-nu-aan-de-rechterkant.mp3",
  "spread-een-magical-vleugel": "common/spread-een-magical-vleugel.mp3",
  "spreid-een-magische-vleugel": "common/spreid-een-magische-vleugel.mp3",
  "teken-4-dunne-rode-diagonale-strepen": "common/teken-4-dunne-rode-diagonale-strepen.mp3",
  "teken-8-blauwe-driehoeken-in-de-hoeken": "common/teken-8-blauwe-driehoeken-in-de-hoeken.mp3",
  "teken-8-blauwe-triangles-in-de-corners": "common/teken-8-blauwe-triangles-in-de-corners.mp3",
  "teken-de-auto-carrosserie": "common/teken-de-auto-carrosserie.mp3",
  "teken-de-back-en-de-ronde-tummy": "common/teken-de-back-en-de-ronde-tummy.mp3",
  "teken-de-biggest-boog": "common/teken-de-biggest-boog.mp3",
  "teken-de-blije-ogen": "common/teken-de-blije-ogen.mp3",
  "teken-de-car-lichaam": "common/teken-de-car-lichaam.mp3",
  "teken-de-deur": "common/teken-de-deur.mp3",
  "teken-de-deur-met-een-deurknop": "common/teken-de-deur-met-een-deurknop.mp3",
  "teken-de-deur-met-een-doorknob": "common/teken-de-deur-met-een-doorknob.mp3",
  "teken-de-face-en-coole-hair": "common/teken-de-face-en-coole-hair.mp3",
  "teken-de-flowing-manen": "common/teken-de-flowing-manen.mp3",
  "teken-de-flowing-manen-down-de-nek": "common/teken-de-flowing-manen-down-de-nek.mp3",
  "teken-de-glooiende-heuvels-onderaan": "common/teken-de-glooiende-heuvels-onderaan.mp3",
  "teken-de-grasgrond": "common/teken-de-grasgrond.mp3",
  "teken-de-grassy-ground": "common/teken-de-grassy-ground.mp3",
  "teken-de-grootste-boog": "common/teken-de-grootste-boog.mp3",
  "teken-de-grote-blije-ogen": "common/teken-de-grote-blije-ogen.mp3",
  "teken-de-grote-curling-golf": "common/teken-de-grote-curling-golf.mp3",
  "teken-de-grote-krullende-golf": "common/teken-de-grote-krullende-golf.mp3",
  "teken-de-hem-then-start-de-grote-cijfer": "common/teken-de-hem-then-start-de-grote-cijfer.mp3",
  "teken-de-hero-s-hoofd": "common/teken-de-hero-s-hoofd.mp3",
  "teken-de-krul-op-het-schild": "common/teken-de-krul-op-het-schild.mp3",
  "teken-de-lange-voet-van-de-slak": "common/teken-de-lange-voet-van-de-slak.mp3",
  "teken-de-left-zijde-of-het-hart": "common/teken-de-left-zijde-of-het-hart.mp3",
  "teken-de-linkerzijde-van-het-hart": "common/teken-de-linkerzijde-van-het-hart.mp3",
  "teken-de-magic-hoorn": "common/teken-de-magic-hoorn.mp3",
  "teken-de-magische-hoorn": "common/teken-de-magische-hoorn.mp3",
  "teken-de-muren-een-groot-vierkant": "common/teken-de-muren-een-groot-vierkant.mp3",
  "teken-de-neus-en-een-lachende-mond": "common/teken-de-neus-en-een-lachende-mond.mp3",
  "teken-de-neus-en-mond": "common/teken-de-neus-en-mond.mp3",
  "teken-de-rolling-hills-at-de-bottom": "common/teken-de-rolling-hills-at-de-bottom.mp3",
  "teken-de-ronde-ijsje-scoop": "common/teken-de-ronde-ijsje-scoop.mp3",
  "teken-de-ronde-lichaam-en-puntige-neus": "common/teken-de-ronde-lichaam-en-puntige-neus.mp3",
  "teken-de-ronde-schep-ijs": "common/teken-de-ronde-schep-ijs.mp3",
  "teken-de-rug-en-het-ronde-buikje": "common/teken-de-rug-en-het-ronde-buikje.mp3",
  "teken-de-schouders-en-de-mouwen": "common/teken-de-schouders-en-de-mouwen.mp3",
  "teken-de-shoulders-en-de-sleeves": "common/teken-de-shoulders-en-de-sleeves.mp3",
  "teken-de-slak-s-lange-foot": "common/teken-de-slak-s-lange-foot.mp3",
  "teken-de-stam": "common/teken-de-stam.mp3",
  "teken-de-stam-met-roots": "common/teken-de-stam-met-roots.mp3",
  "teken-de-stam-met-wortels": "common/teken-de-stam-met-wortels.mp3",
  "teken-de-stengel-en-een-blad": "common/teken-de-stengel-en-een-blad.mp3",
  "teken-de-stengel-en-twee-bladeren": "common/teken-de-stengel-en-twee-bladeren.mp3",
  "teken-de-stengel-en-two-bladeren": "common/teken-de-stengel-en-two-bladeren.mp3",
  "teken-de-swirl-op-de-schild": "common/teken-de-swirl-op-de-schild.mp3",
  "teken-de-twee-zijkanten-en-de-onderkant-van-het-shirt": "common/teken-de-twee-zijkanten-en-de-onderkant-van-het-shirt.mp3",
  "teken-de-two-zijden-en-de-bottom-of-de-shirt": "common/teken-de-two-zijden-en-de-bottom-of-de-shirt.mp3",
  "teken-de-vis-lichaam": "common/teken-de-vis-lichaam.mp3",
  "teken-de-wafellijnen-op-het-hoorntje": "common/teken-de-wafellijnen-op-het-hoorntje.mp3",
  "teken-de-waffle-lijnen-op-de-cone": "common/teken-de-waffle-lijnen-op-de-cone.mp3",
  "teken-de-walls-een-grote-vierkant": "common/teken-de-walls-een-grote-vierkant.mp3",
  "teken-de-wapperende-manen": "common/teken-de-wapperende-manen.mp3",
  "teken-de-wapperende-manen-langs-de-nek": "common/teken-de-wapperende-manen-langs-de-nek.mp3",
  "teken-de-zoom-begin-dan-aan-het-grote-cijfer": "common/teken-de-zoom-begin-dan-aan-het-grote-cijfer.mp3",
  "teken-een-brede-ronde-hoofd": "common/teken-een-brede-ronde-hoofd.mp3",
  "teken-een-brede-streep-van-hoek-tot-hoek": "common/teken-een-brede-streep-van-hoek-tot-hoek.mp3",
  "teken-een-brede-stripe-hoek-to-hoek": "common/teken-een-brede-stripe-hoek-to-hoek.mp3",
  "teken-een-cirkel-binnenin": "common/teken-een-cirkel-binnenin.mp3",
  "teken-een-cirkel-in-de-midden": "common/teken-een-cirkel-in-de-midden.mp3",
  "teken-een-donzige-wolk": "common/teken-een-donzige-wolk.mp3",
  "teken-een-driehoek-aan-de-linkerkant": "common/teken-een-driehoek-aan-de-linkerkant.mp3",
  "teken-een-driehoek-aan-de-linkerrand": "common/teken-een-driehoek-aan-de-linkerrand.mp3",
  "teken-een-driehoek-at-de-left-edge": "common/teken-een-driehoek-at-de-left-edge.mp3",
  "teken-een-driehoek-op-de-left": "common/teken-een-driehoek-op-de-left.mp3",
  "teken-een-driehoek-van-de-zijde": "common/teken-een-driehoek-van-de-zijde.mp3",
  "teken-een-esdoornblad-in-het-midden": "common/teken-een-esdoornblad-in-het-midden.mp3",
  "teken-een-five-punt-ster-in-de-midden": "common/teken-een-five-punt-ster-in-de-midden.mp3",
  "teken-een-fluffy-wolk": "common/teken-een-fluffy-wolk.mp3",
  "teken-een-fonkelende-ster": "common/teken-een-fonkelende-ster.mp3",
  "teken-een-gebogen-lijn-down-de-midden-that-splits-de-face": "common/teken-een-gebogen-lijn-down-de-midden-that-splits-de-face.mp3",
  "teken-een-gebogen-lijn-in-het-midden-die-verdeelt-het-gezicht": "common/teken-een-gebogen-lijn-in-het-midden-die-verdeelt-het-gezicht.mp3",
  "teken-een-groene-five-punt-ster": "common/teken-een-groene-five-punt-ster.mp3",
  "teken-een-groene-vijfpuntige-ster": "common/teken-een-groene-vijfpuntige-ster.mp3",
  "teken-een-grote-cirkel-in-de-midden": "common/teken-een-grote-cirkel-in-de-midden.mp3",
  "teken-een-grote-dikke-rode-kruis": "common/teken-een-grote-dikke-rode-kruis.mp3",
  "teken-een-grote-donzige-manen": "common/teken-een-grote-donzige-manen.mp3",
  "teken-een-grote-donzige-wolk": "common/teken-een-grote-donzige-wolk.mp3",
  "teken-een-grote-fluffy-manen": "common/teken-een-grote-fluffy-manen.mp3",
  "teken-een-grote-fluffy-wolk": "common/teken-een-grote-fluffy-wolk.mp3",
  "teken-een-grote-fonkelende-ster": "common/teken-een-grote-fonkelende-ster.mp3",
  "teken-een-grote-gele-driehoek": "common/teken-een-grote-gele-driehoek.mp3",
  "teken-een-grote-hoofd-vorm": "common/teken-een-grote-hoofd-vorm.mp3",
  "teken-een-grote-rode-kruis": "common/teken-een-grote-rode-kruis.mp3",
  "teken-een-grote-ronde-hoofd": "common/teken-een-grote-ronde-hoofd.mp3",
  "teken-een-grote-ronde-lichaam": "common/teken-een-grote-ronde-lichaam.mp3",
  "teken-een-grote-ronde-pinguin-lichaam": "common/teken-een-grote-ronde-pinguin-lichaam.mp3",
  "teken-een-grote-ronde-zon": "common/teken-een-grote-ronde-zon.mp3",
  "teken-een-grote-ruit": "common/teken-een-grote-ruit.mp3",
  "teken-een-grote-ster": "common/teken-een-grote-ster.mp3",
  "teken-een-grote-ster-in-de-midden": "common/teken-een-grote-ster-in-de-midden.mp3",
  "teken-een-grote-witte-x-hoek-to-hoek": "common/teken-een-grote-witte-x-hoek-to-hoek.mp3",
  "teken-een-grote-witte-x-van-hoek-tot-hoek": "common/teken-een-grote-witte-x-van-hoek-tot-hoek.mp3",
  "teken-een-halve-maan": "common/teken-een-halve-maan.mp3",
  "teken-een-halve-maan-maan": "common/teken-een-halve-maan-maan.mp3",
  "teken-een-klein-huisje-op-de-achtergrond": "common/teken-een-klein-huisje-op-de-achtergrond.mp3",
  "teken-een-klein-rood-embleem-in-het-midden": "common/teken-een-klein-rood-embleem-in-het-midden.mp3",
  "teken-een-kleine-adelaar-in-het-midden": "common/teken-een-kleine-adelaar-in-het-midden.mp3",
  "teken-een-kleine-cactus-in-de-midden": "common/teken-een-kleine-cactus-in-de-midden.mp3",
  "teken-een-kleine-eagle-in-de-midden": "common/teken-een-kleine-eagle-in-de-midden.mp3",
  "teken-een-kleine-house-behind": "common/teken-een-kleine-house-behind.mp3",
  "teken-een-kleine-rode-emblem-in-de-midden": "common/teken-een-kleine-rode-emblem-in-de-midden.mp3",
  "teken-een-kleine-witte-vak-in-de-midden": "common/teken-een-kleine-witte-vak-in-de-midden.mp3",
  "teken-een-lachende-zon-in-het-midden": "common/teken-een-lachende-zon-in-het-midden.mp3",
  "teken-een-lachende-zon-in-het-vak": "common/teken-een-lachende-zon-in-het-vak.mp3",
  "teken-een-lang-zwaard-eronder": "common/teken-een-lang-zwaard-eronder.mp3",
  "teken-een-lange-paard-hoofd-en-nek-van-de-zijde": "common/teken-een-lange-paard-hoofd-en-nek-van-de-zijde.mp3",
  "teken-een-lange-sword-underneath": "common/teken-een-lange-sword-underneath.mp3",
  "teken-een-lijn-op-de-snavel": "common/teken-een-lijn-op-de-snavel.mp3",
  "teken-een-maple-blad-in-de-midden": "common/teken-een-maple-blad-in-de-midden.mp3",
  "teken-een-palm-boom-op-een-hill": "common/teken-een-palm-boom-op-een-hill.mp3",
  "teken-een-palmboom-op-een-heuvel": "common/teken-een-palmboom-op-een-heuvel.mp3",
  "teken-een-rond-insigne-in-het-midden": "common/teken-een-rond-insigne-in-het-midden.mp3",
  "teken-een-ronde-badge-in-de-midden": "common/teken-een-ronde-badge-in-de-midden.mp3",
  "teken-een-ronde-hoofd": "common/teken-een-ronde-hoofd.mp3",
  "teken-een-scheef-gezicht": "common/teken-een-scheef-gezicht.mp3",
  "teken-een-schild-en-een-kroon": "common/teken-een-schild-en-een-kroon.mp3",
  "teken-een-schild-in-de-midden": "common/teken-een-schild-in-de-midden.mp3",
  "teken-een-schild-met-een-bird-bovenop": "common/teken-een-schild-met-een-bird-bovenop.mp3",
  "teken-een-schild-met-een-vogel-bovenop": "common/teken-een-schild-met-een-vogel-bovenop.mp3",
  "teken-een-schuine-groene-y-overdwars-op-de-vlag": "common/teken-een-schuine-groene-y-overdwars-op-de-vlag.mp3",
  "teken-een-smiling-zon-in-de-midden": "common/teken-een-smiling-zon-in-de-midden.mp3",
  "teken-een-smiling-zon-in-het-vak": "common/teken-een-smiling-zon-in-het-vak.mp3",
  "teken-een-ster-binnenin-een-ring": "common/teken-een-ster-binnenin-een-ring.mp3",
  "teken-een-vijfpuntige-ster-in-het-midden": "common/teken-een-vijfpuntige-ster-in-het-midden.mp3",
  "teken-een-wiel-in-de-midden": "common/teken-een-wiel-in-de-midden.mp3",
  "teken-een-wonky-face-vorm": "common/teken-een-wonky-face-vorm.mp3",
  "teken-haar-grote-wapperende-jurk": "common/teken-haar-grote-wapperende-jurk.mp3",
  "teken-haar-kasteel-in-de-verte": "common/teken-haar-kasteel-in-de-verte.mp3",
  "teken-haar-pony": "common/teken-haar-pony.mp3",
  "teken-her-grote-flowy-dress": "common/teken-her-grote-flowy-dress.mp3",
  "teken-her-hair-fringe": "common/teken-her-hair-fringe.mp3",
  "teken-het-gezicht-en-stoer-haar": "common/teken-het-gezicht-en-stoer-haar.mp3",
  "teken-het-hoofd-met-een-soft-snuit": "common/teken-het-hoofd-met-een-soft-snuit.mp3",
  "teken-het-hoofd-met-een-zachte-snuit": "common/teken-het-hoofd-met-een-zachte-snuit.mp3",
  "teken-het-hoofd-van-de-held": "common/teken-het-hoofd-van-de-held.mp3",
  "teken-het-lichaam-de-segmenten-en-de-antennes": "common/teken-het-lichaam-de-segmenten-en-de-antennes.mp3",
  "teken-het-lichaam-en-antennae": "common/teken-het-lichaam-en-antennae.mp3",
  "teken-het-lichaam-en-de-antennes": "common/teken-het-lichaam-en-de-antennes.mp3",
  "teken-het-lichaam-segments-en-antennae": "common/teken-het-lichaam-segments-en-antennae.mp3",
  "teken-het-vak-van-de-vlag": "common/teken-het-vak-van-de-vlag.mp3",
  "teken-je-grote-broer-of-zus": "common/teken-je-grote-broer-of-zus.mp3",
  "teken-mama": "common/teken-mama.mp3",
  "teken-nu-twee-grote-ogen": "common/teken-nu-twee-grote-ogen.mp3",
  "teken-nu-two-grote-ogen": "common/teken-nu-two-grote-ogen.mp3",
  "teken-ogen-en-wenkbrauwen": "common/teken-ogen-en-wenkbrauwen.mp3",
  "teken-papa": "common/teken-papa.mp3",
  "teken-twee-sterren": "common/teken-twee-sterren.mp3",
  "teken-twee-witte-sterren-in-de-hoek": "common/teken-twee-witte-sterren-in-de-hoek.mp3",
  "tover-een-stormwolk-rechts": "common/tover-een-stormwolk-rechts.mp3",
  "trek-de-zwarte-rand": "common/trek-de-zwarte-rand.mp3",
  "trek-de-zwarte-randen": "common/trek-de-zwarte-randen.mp3",
  "veeg-de-pony-rond-de-hoorn": "common/veeg-de-pony-rond-de-hoorn.mp3",
  "verdeel-het-in-vier-vakken": "common/verdeel-het-in-vier-vakken.mp3",
  "voeg-10-kleine-sterren-in-een-cirkel": "common/voeg-10-kleine-sterren-in-een-cirkel.mp3",
  "voeg-13-strepen-toe-overdwars": "common/voeg-13-strepen-toe-overdwars.mp3",
  "voeg-3-strepen-toe-overdwars": "common/voeg-3-strepen-toe-overdwars.mp3",
  "voeg-3-strepen-toe-overdwars-over-de-rest": "common/voeg-3-strepen-toe-overdwars-over-de-rest.mp3",
  "voeg-3-strepen-toe-van-boven-naar-beneden": "common/voeg-3-strepen-toe-van-boven-naar-beneden.mp3",
  "voeg-50-kleine-sterren-toe": "common/voeg-50-kleine-sterren-toe.mp3",
  "voeg-9-strepen-toe-overdwars": "common/voeg-9-strepen-toe-overdwars.mp3",
  "voeg-acht-blaadjes-all-rondom": "common/voeg-acht-blaadjes-all-rondom.mp3",
  "voeg-acht-blaadjes-rondom-toe": "common/voeg-acht-blaadjes-rondom-toe.mp3",
  "voeg-armen-en-benen": "common/voeg-armen-en-benen.mp3",
  "voeg-blaadjes-all-rondom": "common/voeg-blaadjes-all-rondom.mp3",
  "voeg-blaadjes-rondom-toe": "common/voeg-blaadjes-rondom-toe.mp3",
  "voeg-bobbelige-platen-toe-langs-zijn-rug": "common/voeg-bobbelige-platen-toe-langs-zijn-rug.mp3",
  "voeg-coole-zonnebril-toe": "common/voeg-coole-zonnebril-toe.mp3",
  "voeg-coole-zwierige-haren-toe": "common/voeg-coole-zwierige-haren-toe.mp3",
  "voeg-de-achterpoten-toe": "common/voeg-de-achterpoten-toe.mp3",
  "voeg-de-back-benen": "common/voeg-de-back-benen.mp3",
  "voeg-de-bottom-vleugels": "common/voeg-de-bottom-vleugels.mp3",
  "voeg-de-cuffs-en-de-shoulder-seams": "common/voeg-de-cuffs-en-de-shoulder-seams.mp3",
  "voeg-de-eerste-rij-regendruppels-toe": "common/voeg-de-eerste-rij-regendruppels-toe.mp3",
  "voeg-de-eerste-rij-stekels-toe": "common/voeg-de-eerste-rij-stekels-toe.mp3",
  "voeg-de-first-rij-of-raindrops": "common/voeg-de-first-rij-of-raindrops.mp3",
  "voeg-de-first-rij-of-stekels": "common/voeg-de-first-rij-of-stekels.mp3",
  "voeg-de-front-benen-en-poten": "common/voeg-de-front-benen-en-poten.mp3",
  "voeg-de-front-benen-one-prancing": "common/voeg-de-front-benen-one-prancing.mp3",
  "voeg-de-gill-lijn-en-an-oog": "common/voeg-de-gill-lijn-en-an-oog.mp3",
  "voeg-de-grote-bovenvleugels-toe": "common/voeg-de-grote-bovenvleugels-toe.mp3",
  "voeg-de-grote-ronde-schild": "common/voeg-de-grote-ronde-schild.mp3",
  "voeg-de-grote-top-vleugels": "common/voeg-de-grote-top-vleugels.mp3",
  "voeg-de-halsband-at-de-nek": "common/voeg-de-halsband-at-de-nek.mp3",
  "voeg-de-halsband-om-de-nek-toe": "common/voeg-de-halsband-om-de-nek-toe.mp3",
  "voeg-de-hoeven-en-een-zwierige-staart-toe": "common/voeg-de-hoeven-en-een-zwierige-staart-toe.mp3",
  "voeg-de-hond-van-het-gezin-toe": "common/voeg-de-hond-van-het-gezin-toe.mp3",
  "voeg-de-hooves-en-een-swishy-staart": "common/voeg-de-hooves-en-een-swishy-staart.mp3",
  "voeg-de-kieuwlijn-en-een-oog-toe": "common/voeg-de-kieuwlijn-en-een-oog-toe.mp3",
  "voeg-de-kleine-berg-fuji-op-de-achtergrond-toe": "common/voeg-de-kleine-berg-fuji-op-de-achtergrond-toe.mp3",
  "voeg-de-manchetten-en-de-schoudernaden-toe": "common/voeg-de-manchetten-en-de-schoudernaden-toe.mp3",
  "voeg-de-microfoon": "common/voeg-de-microfoon.mp3",
  "voeg-de-midden-of-de-bloem": "common/voeg-de-midden-of-de-bloem.mp3",
  "voeg-de-neus-mond-en-snorharen": "common/voeg-de-neus-mond-en-snorharen.mp3",
  "voeg-de-ogen": "common/voeg-de-ogen.mp3",
  "voeg-de-ogen-en-eyebrows": "common/voeg-de-ogen-en-eyebrows.mp3",
  "voeg-de-ogen-en-wenkbrauwen-toe": "common/voeg-de-ogen-en-wenkbrauwen-toe.mp3",
  "voeg-de-onderarmlijnen-en-de-zijnaden-toe": "common/voeg-de-onderarmlijnen-en-de-zijnaden-toe.mp3",
  "voeg-de-ondervleugels-toe": "common/voeg-de-ondervleugels-toe.mp3",
  "voeg-de-puntige-cone-underneath": "common/voeg-de-puntige-cone-underneath.mp3",
  "voeg-de-ramen-toe": "common/voeg-de-ramen-toe.mp3",
  "voeg-de-road": "common/voeg-de-road.mp3",
  "voeg-de-ronde-midden": "common/voeg-de-ronde-midden.mp3",
  "voeg-de-roof-en-een-chimney": "common/voeg-de-roof-en-een-chimney.mp3",
  "voeg-de-sitting-lichaam": "common/voeg-de-sitting-lichaam.mp3",
  "voeg-de-sterren": "common/voeg-de-sterren.mp3",
  "voeg-de-underarm-lijnen-en-de-zijde-seams": "common/voeg-de-underarm-lijnen-en-de-zijde-seams.mp3",
  "voeg-de-voorbenen-eentje-steigerend": "common/voeg-de-voorbenen-eentje-steigerend.mp3",
  "voeg-de-voorpoten-en-pootjes-toe": "common/voeg-de-voorpoten-en-pootjes-toe.mp3",
  "voeg-de-weg-toe": "common/voeg-de-weg-toe.mp3",
  "voeg-de-windows": "common/voeg-de-windows.mp3",
  "voeg-de-witte-delen-van-de-ogen-toe": "common/voeg-de-witte-delen-van-de-ogen-toe.mp3",
  "voeg-de-witte-parts-of-de-ogen": "common/voeg-de-witte-parts-of-de-ogen.mp3",
  "voeg-diagonale-rays-in-de-corners": "common/voeg-diagonale-rays-in-de-corners.mp3",
  "voeg-diagonale-stralen-in-de-hoeken-toe": "common/voeg-diagonale-stralen-in-de-hoeken-toe.mp3",
  "voeg-dunne-rode-lijnen-tussen-de-strepen": "common/voeg-dunne-rode-lijnen-tussen-de-strepen.mp3",
  "voeg-een-adelaar-bovenop-toe": "common/voeg-een-adelaar-bovenop-toe.mp3",
  "voeg-een-appel-op-zijn-back": "common/voeg-een-appel-op-zijn-back.mp3",
  "voeg-een-appel-op-zijn-rug-toe": "common/voeg-een-appel-op-zijn-rug-toe.mp3",
  "voeg-een-band-over-de-onderste-helft": "common/voeg-een-band-over-de-onderste-helft.mp3",
  "voeg-een-blije-oog": "common/voeg-een-blije-oog.mp3",
  "voeg-een-brede-oranje-snavel": "common/voeg-een-brede-oranje-snavel.mp3",
  "voeg-een-brede-streep-overdwars-onderaan-toe": "common/voeg-een-brede-streep-overdwars-onderaan-toe.mp3",
  "voeg-een-brede-stripe-overdwars-de-bottom": "common/voeg-een-brede-stripe-overdwars-de-bottom.mp3",
  "voeg-een-coole-zonnebril-toe": "common/voeg-een-coole-zonnebril-toe.mp3",
  "voeg-een-cute-neus": "common/voeg-een-cute-neus.mp3",
  "voeg-een-dappere-glimlach-toe": "common/voeg-een-dappere-glimlach-toe.mp3",
  "voeg-een-derde-rij-piepkleine-stekeltjes-toe": "common/voeg-een-derde-rij-piepkleine-stekeltjes-toe.mp3",
  "voeg-een-deur-handvat-en-koplamp": "common/voeg-een-deur-handvat-en-koplamp.mp3",
  "voeg-een-dik-wit-kruis-in-het-midden-toe": "common/voeg-een-dik-wit-kruis-in-het-midden-toe.mp3",
  "voeg-een-donzige-wolk-aan-beide-kanten-toe": "common/voeg-een-donzige-wolk-aan-beide-kanten-toe.mp3",
  "voeg-een-donzige-wolk-links-toe": "common/voeg-een-donzige-wolk-links-toe.mp3",
  "voeg-een-donzige-wolk-toe": "common/voeg-een-donzige-wolk-toe.mp3",
  "voeg-een-driehoek-roof": "common/voeg-een-driehoek-roof.mp3",
  "voeg-een-driehoekig-dak-toe": "common/voeg-een-driehoekig-dak-toe.mp3",
  "voeg-een-dunner-kruis-binnenin-toe": "common/voeg-een-dunner-kruis-binnenin-toe.mp3",
  "voeg-een-dunnere-streep-erin-toe": "common/voeg-een-dunnere-streep-erin-toe.mp3",
  "voeg-een-eagle-bovenop": "common/voeg-een-eagle-bovenop.mp3",
  "voeg-een-fat-witte-kruis-in-de-midden": "common/voeg-een-fat-witte-kruis-in-de-midden.mp3",
  "voeg-een-felle-zon-toe": "common/voeg-een-felle-zon-toe.mp3",
  "voeg-een-five-punt-ster": "common/voeg-een-five-punt-ster.mp3",
  "voeg-een-flowing-cape": "common/voeg-een-flowing-cape.mp3",
  "voeg-een-fluffy-wolk": "common/voeg-een-fluffy-wolk.mp3",
  "voeg-een-fluffy-wolk-at-each-end": "common/voeg-een-fluffy-wolk-at-each-end.mp3",
  "voeg-een-fluffy-wolk-op-de-left": "common/voeg-een-fluffy-wolk-op-de-left.mp3",
  "voeg-een-fonkelende-kroon-met-juwelen-toe": "common/voeg-een-fonkelende-kroon-met-juwelen-toe.mp3",
  "voeg-een-fonkelende-kroon-toe": "common/voeg-een-fonkelende-kroon-toe.mp3",
  "voeg-een-gebogen-band-toe": "common/voeg-een-gebogen-band-toe.mp3",
  "voeg-een-glanzend-accent-toe": "common/voeg-een-glanzend-accent-toe.mp3",
  "voeg-een-glanzende-ster-op-het-shirt-toe": "common/voeg-een-glanzende-ster-op-het-shirt-toe.mp3",
  "voeg-een-glimlach-en-roze-wangen-toe": "common/voeg-een-glimlach-en-roze-wangen-toe.mp3",
  "voeg-een-glimlach-en-snorharen-toe": "common/voeg-een-glimlach-en-snorharen-toe.mp3",
  "voeg-een-glimlach-toe": "common/voeg-een-glimlach-toe.mp3",
  "voeg-een-gloeiende-maan-en-fonkelende-sterren-toe": "common/voeg-een-gloeiende-maan-en-fonkelende-sterren-toe.mp3",
  "voeg-een-glowing-maan-en-fonkelende-sterren": "common/voeg-een-glowing-maan-en-fonkelende-sterren.mp3",
  "voeg-een-groot-oog-en-een-neusgat-toe": "common/voeg-een-groot-oog-en-een-neusgat-toe.mp3",
  "voeg-een-grote-glimlach-toe": "common/voeg-een-grote-glimlach-toe.mp3",
  "voeg-een-grote-snuit": "common/voeg-een-grote-snuit.mp3",
  "voeg-een-grote-snuit-en-een-glimlach-toe": "common/voeg-een-grote-snuit-en-een-glimlach-toe.mp3",
  "voeg-een-grote-vriendelijke-glimlach-toe": "common/voeg-een-grote-vriendelijke-glimlach-toe.mp3",
  "voeg-een-grote-wapperende-cape-toe": "common/voeg-een-grote-wapperende-cape-toe.mp3",
  "voeg-een-grote-wolk-van-bladeren-toe": "common/voeg-een-grote-wolk-van-bladeren-toe.mp3",
  "voeg-een-grote-zig-zag-bliksem-bliksemschicht": "common/voeg-een-grote-zig-zag-bliksem-bliksemschicht.mp3",
  "voeg-een-grote-zingende-glimlach-toe": "common/voeg-een-grote-zingende-glimlach-toe.mp3",
  "voeg-een-halsband-met-een-naamplaatje-toe": "common/voeg-een-halsband-met-een-naamplaatje-toe.mp3",
  "voeg-een-halve-maan-toe": "common/voeg-een-halve-maan-toe.mp3",
  "voeg-een-heldengordel-toe": "common/voeg-een-heldengordel-toe.mp3",
  "voeg-een-hero-belt": "common/voeg-een-hero-belt.mp3",
  "voeg-een-klein-armpje-toe": "common/voeg-een-klein-armpje-toe.mp3",
  "voeg-een-klein-groepje-sterren-toe": "common/voeg-een-klein-groepje-sterren-toe.mp3",
  "voeg-een-klein-plukje-veren-bovenop-toe": "common/voeg-een-klein-plukje-veren-bovenop-toe.mp3",
  "voeg-een-klein-tongetje-toe": "common/voeg-een-klein-tongetje-toe.mp3",
  "voeg-een-klein-vogeltje-toe": "common/voeg-een-klein-vogeltje-toe.mp3",
  "voeg-een-kleine-arm": "common/voeg-een-kleine-arm.mp3",
  "voeg-een-kleine-bird": "common/voeg-een-kleine-bird.mp3",
  "voeg-een-kleine-cluster-of-sterren": "common/voeg-een-kleine-cluster-of-sterren.mp3",
  "voeg-een-kleine-driehoek-neus": "common/voeg-een-kleine-driehoek-neus.mp3",
  "voeg-een-kleine-hek-en-bloemen": "common/voeg-een-kleine-hek-en-bloemen.mp3",
  "voeg-een-kleine-neus": "common/voeg-een-kleine-neus.mp3",
  "voeg-een-kleine-oranje-snavel": "common/voeg-een-kleine-oranje-snavel.mp3",
  "voeg-een-kleine-veer-tuft-bovenop": "common/voeg-een-kleine-veer-tuft-bovenop.mp3",
  "voeg-een-kleurrijke-paraplu-toe": "common/voeg-een-kleurrijke-paraplu-toe.mp3",
  "voeg-een-kruis-een-hoge-lijn-en-een-brede-lijn": "common/voeg-een-kruis-een-hoge-lijn-en-een-brede-lijn.mp3",
  "voeg-een-kruis-in-het-vak": "common/voeg-een-kruis-in-het-vak.mp3",
  "voeg-een-krullende-staart": "common/voeg-een-krullende-staart.mp3",
  "voeg-een-kwispelende-staart-toe": "common/voeg-een-kwispelende-staart-toe.mp3",
  "voeg-een-lachende-mond-en-een-voorpluk": "common/voeg-een-lachende-mond-en-een-voorpluk.mp3",
  "voeg-een-lange-nek-en-een-grote-hoofd": "common/voeg-een-lange-nek-en-een-grote-hoofd.mp3",
  "voeg-een-lange-paard-hoofd-van-de-zijde": "common/voeg-een-lange-paard-hoofd-van-de-zijde.mp3",
  "voeg-een-lange-stam": "common/voeg-een-lange-stam.mp3",
  "voeg-een-lange-swishy-staart": "common/voeg-een-lange-swishy-staart.mp3",
  "voeg-een-lange-zwiepende-staart-toe": "common/voeg-een-lange-zwiepende-staart-toe.mp3",
  "voeg-een-lijn-down": "common/voeg-een-lijn-down.mp3",
  "voeg-een-lijn-down-de-midden": "common/voeg-een-lijn-down-de-midden.mp3",
  "voeg-een-lijn-down-for-de-rode-bar": "common/voeg-een-lijn-down-for-de-rode-bar.mp3",
  "voeg-een-lijn-naar-beneden-in-het-midden-toe": "common/voeg-een-lijn-naar-beneden-in-het-midden-toe.mp3",
  "voeg-een-lijn-naar-beneden-toe": "common/voeg-een-lijn-naar-beneden-toe.mp3",
  "voeg-een-lijn-naar-beneden-voor-de-rode-balk-toe": "common/voeg-een-lijn-naar-beneden-voor-de-rode-balk-toe.mp3",
  "voeg-een-lijn-of-kleine-sterren": "common/voeg-een-lijn-of-kleine-sterren.mp3",
  "voeg-een-lijn-overdwars-de-midden": "common/voeg-een-lijn-overdwars-de-midden.mp3",
  "voeg-een-magic-wand": "common/voeg-een-magic-wand.mp3",
  "voeg-een-microfoon-met-een-snoer": "common/voeg-een-microfoon-met-een-snoer.mp3",
  "voeg-een-microfoon-om-in-te-zingen-toe": "common/voeg-een-microfoon-om-in-te-zingen-toe.mp3",
  "voeg-een-microfoon-to-sing-in": "common/voeg-een-microfoon-to-sing-in.mp3",
  "voeg-een-neus-en-een-smile": "common/voeg-een-neus-en-een-smile.mp3",
  "voeg-een-neus-seen-van-de-zijde": "common/voeg-een-neus-seen-van-de-zijde.mp3",
  "voeg-een-neus-van-opzij-toe": "common/voeg-een-neus-van-opzij-toe.mp3",
  "voeg-een-neusje-en-een-glimlach-toe": "common/voeg-een-neusje-en-een-glimlach-toe.mp3",
  "voeg-een-oog-een-neusgat-en-een-glimlach-toe": "common/voeg-een-oog-een-neusgat-en-een-glimlach-toe.mp3",
  "voeg-een-oog-een-neusgat-en-een-smile": "common/voeg-een-oog-een-neusgat-en-een-smile.mp3",
  "voeg-een-oog-en-een-blije-glimlach-toe": "common/voeg-een-oog-en-een-blije-glimlach-toe.mp3",
  "voeg-een-oog-en-een-blije-smile": "common/voeg-een-oog-en-een-blije-smile.mp3",
  "voeg-een-oog-en-stippen": "common/voeg-een-oog-en-stippen.mp3",
  "voeg-een-paar-grote-regendruppels-toe": "common/voeg-een-paar-grote-regendruppels-toe.mp3",
  "voeg-een-puntige-oor": "common/voeg-een-puntige-oor.mp3",
  "voeg-een-rond-gezichtje-bovenop-toe": "common/voeg-een-rond-gezichtje-bovenop-toe.mp3",
  "voeg-een-ronde-face-bovenop": "common/voeg-een-ronde-face-bovenop.mp3",
  "voeg-een-roze-wang-en-een-glimlach-toe": "common/voeg-een-roze-wang-en-een-glimlach-toe.mp3",
  "voeg-een-roze-wang-en-een-smile": "common/voeg-een-roze-wang-en-een-smile.mp3",
  "voeg-een-schattig-neusje-toe": "common/voeg-een-schattig-neusje-toe.mp3",
  "voeg-een-scheve-glimlach-toe": "common/voeg-een-scheve-glimlach-toe.mp3",
  "voeg-een-second-rij-of-stekels": "common/voeg-een-second-rij-of-stekels.mp3",
  "voeg-een-shiny-highlight": "common/voeg-een-shiny-highlight.mp3",
  "voeg-een-shiny-ster-op-de-shirt": "common/voeg-een-shiny-ster-op-de-shirt.mp3",
  "voeg-een-smile": "common/voeg-een-smile.mp3",
  "voeg-een-smile-en-roze-wangen": "common/voeg-een-smile-en-roze-wangen.mp3",
  "voeg-een-smile-en-snorharen": "common/voeg-een-smile-en-snorharen.mp3",
  "voeg-een-soft-snuit": "common/voeg-een-soft-snuit.mp3",
  "voeg-een-soft-witte-tummy": "common/voeg-een-soft-witte-tummy.mp3",
  "voeg-een-sparkly-jewelled-kroon": "common/voeg-een-sparkly-jewelled-kroon.mp3",
  "voeg-een-sparkly-kroon": "common/voeg-een-sparkly-kroon.mp3",
  "voeg-een-spetterende-plas-toe": "common/voeg-een-spetterende-plas-toe.mp3",
  "voeg-een-spetterende-staart-toe": "common/voeg-een-spetterende-staart-toe.mp3",
  "voeg-een-splashy-puddle": "common/voeg-een-splashy-puddle.mp3",
  "voeg-een-splashy-staart": "common/voeg-een-splashy-staart.mp3",
  "voeg-een-ster": "common/voeg-een-ster.mp3",
  "voeg-een-ster-in-de-bovenhoek-toe": "common/voeg-een-ster-in-de-bovenhoek-toe.mp3",
  "voeg-een-ster-in-de-top-hoek": "common/voeg-een-ster-in-de-top-hoek.mp3",
  "voeg-een-ster-met-zeven-punten": "common/voeg-een-ster-met-zeven-punten.mp3",
  "voeg-een-swishy-staart": "common/voeg-een-swishy-staart.mp3",
  "voeg-een-thinner-kruis-binnenin": "common/voeg-een-thinner-kruis-binnenin.mp3",
  "voeg-een-thinner-stripe-binnenin-it": "common/voeg-een-thinner-stripe-binnenin-it.mp3",
  "voeg-een-third-rij-of-piepkleine-stekels": "common/voeg-een-third-rij-of-piepkleine-stekels.mp3",
  "voeg-een-toverstaf-toe": "common/voeg-een-toverstaf-toe.mp3",
  "voeg-een-tweede-rij-stekels-toe": "common/voeg-een-tweede-rij-stekels-toe.mp3",
  "voeg-een-vak-in-de-hoek": "common/voeg-een-vak-in-de-hoek.mp3",
  "voeg-een-vak-in-de-hoek-voor-de-sterren": "common/voeg-een-vak-in-de-hoek-voor-de-sterren.mp3",
  "voeg-een-vak-in-de-hoek-voor-de-zon": "common/voeg-een-vak-in-de-hoek-voor-de-zon.mp3",
  "voeg-een-vijfpuntige-ster-toe": "common/voeg-een-vijfpuntige-ster-toe.mp3",
  "voeg-een-vin-bovenop-en-bottom": "common/voeg-een-vin-bovenop-en-bottom.mp3",
  "voeg-een-vin-bovenop-en-onderaan-toe": "common/voeg-een-vin-bovenop-en-onderaan-toe.mp3",
  "voeg-een-wagging-staart": "common/voeg-een-wagging-staart.mp3",
  "voeg-een-wapperende-cape-toe": "common/voeg-een-wapperende-cape-toe.mp3",
  "voeg-een-water-spout": "common/voeg-een-water-spout.mp3",
  "voeg-een-waterstraal-toe": "common/voeg-een-waterstraal-toe.mp3",
  "voeg-een-witte-snuit-in-de-midden": "common/voeg-een-witte-snuit-in-de-midden.mp3",
  "voeg-een-zacht-wit-buikje-toe": "common/voeg-een-zacht-wit-buikje-toe.mp3",
  "voeg-een-zachte-snuit-toe": "common/voeg-een-zachte-snuit-toe.mp3",
  "voeg-een-zig-zag-bliksem-bliksemschicht": "common/voeg-een-zig-zag-bliksem-bliksemschicht.mp3",
  "voeg-een-zig-zag-lijn-down": "common/voeg-een-zig-zag-lijn-down.mp3",
  "voeg-een-zigzaglijn-naar-beneden-toe": "common/voeg-een-zigzaglijn-naar-beneden-toe.mp3",
  "voeg-een-zijde-spiegel-en-een-wolkje-of-uitlaat": "common/voeg-een-zijde-spiegel-en-een-wolkje-of-uitlaat.mp3",
  "voeg-een-zoemende-bij-toe": "common/voeg-een-zoemende-bij-toe.mp3",
  "voeg-een-zwierige-staart-toe": "common/voeg-een-zwierige-staart-toe.mp3",
  "voeg-foamy-klauwen-bovenop": "common/voeg-foamy-klauwen-bovenop.mp3",
  "voeg-fonkelende-sterren-toe": "common/voeg-fonkelende-sterren-toe.mp3",
  "voeg-fonkelingen-eromheen-toe": "common/voeg-fonkelingen-eromheen-toe.mp3",
  "voeg-fonkelingen-rondom-toe": "common/voeg-fonkelingen-rondom-toe.mp3",
  "voeg-front-benen-en-poten": "common/voeg-front-benen-en-poten.mp3",
  "voeg-gebogen-schubben": "common/voeg-gebogen-schubben.mp3",
  "voeg-gezellige-strepen-op-zijn-lichaam": "common/voeg-gezellige-strepen-op-zijn-lichaam.mp3",
  "voeg-glanzende-wieldoppen-in-de-wielen-toe": "common/voeg-glanzende-wieldoppen-in-de-wielen-toe.mp3",
  "voeg-golvend-zeewier-toe": "common/voeg-golvend-zeewier-toe.mp3",
  "voeg-grote-krullen-in-de-lucht-toe": "common/voeg-grote-krullen-in-de-lucht-toe.mp3",
  "voeg-grote-ronde-wielen": "common/voeg-grote-ronde-wielen.mp3",
  "voeg-grote-scherpe-tanden": "common/voeg-grote-scherpe-tanden.mp3",
  "voeg-grote-stippen-op-de-vleugels": "common/voeg-grote-stippen-op-de-vleugels.mp3",
  "voeg-grote-swirls-in-de-sky": "common/voeg-grote-swirls-in-de-sky.mp3",
  "voeg-heerlijke-appels-toe": "common/voeg-heerlijke-appels-toe.mp3",
  "voeg-het-dak-en-een-schoorsteen-toe": "common/voeg-het-dak-en-een-schoorsteen-toe.mp3",
  "voeg-het-lichaam": "common/voeg-het-lichaam.mp3",
  "voeg-het-lichaam-armen-en-benen": "common/voeg-het-lichaam-armen-en-benen.mp3",
  "voeg-het-lichaam-en-halsband": "common/voeg-het-lichaam-en-halsband.mp3",
  "voeg-het-lichaam-en-het-pak-toe": "common/voeg-het-lichaam-en-het-pak-toe.mp3",
  "voeg-het-lichaam-en-outfit": "common/voeg-het-lichaam-en-outfit.mp3",
  "voeg-het-oog-de-neus-en-een-glimlach-toe": "common/voeg-het-oog-de-neus-en-een-glimlach-toe.mp3",
  "voeg-het-oog-mask": "common/voeg-het-oog-mask.mp3",
  "voeg-het-oog-mask-en-ogen": "common/voeg-het-oog-mask-en-ogen.mp3",
  "voeg-het-oog-neus-en-een-smile": "common/voeg-het-oog-neus-en-een-smile.mp3",
  "voeg-het-oogmasker-en-de-ogen-toe": "common/voeg-het-oogmasker-en-de-ogen-toe.mp3",
  "voeg-het-oogmasker-toe": "common/voeg-het-oogmasker-toe.mp3",
  "voeg-het-puntige-hoorntje-eronder-toe": "common/voeg-het-puntige-hoorntje-eronder-toe.mp3",
  "voeg-het-zittende-lichaam-toe": "common/voeg-het-zittende-lichaam-toe.mp3",
  "voeg-kleine-bars-in-de-corners": "common/voeg-kleine-bars-in-de-corners.mp3",
  "voeg-kleine-mount-fuji-behind": "common/voeg-kleine-mount-fuji-behind.mp3",
  "voeg-kleine-staafjes-in-de-hoeken-toe": "common/voeg-kleine-staafjes-in-de-hoeken-toe.mp3",
  "voeg-kleine-sterren-in-de-lucht-toe": "common/voeg-kleine-sterren-in-de-lucht-toe.mp3",
  "voeg-kleine-sterren-in-de-sky": "common/voeg-kleine-sterren-in-de-sky.mp3",
  "voeg-kleine-zaadjes-in-de-midden": "common/voeg-kleine-zaadjes-in-de-midden.mp3",
  "voeg-kleurrijke-lippen-toe": "common/voeg-kleurrijke-lippen-toe.mp3",
  "voeg-krullende-rook-uit-de-schoorsteen-toe": "common/voeg-krullende-rook-uit-de-schoorsteen-toe.mp3",
  "voeg-krullende-smoke-van-de-chimney": "common/voeg-krullende-smoke-van-de-chimney.mp3",
  "voeg-krullerige-patronen-op-de-vleugels-toe": "common/voeg-krullerige-patronen-op-de-vleugels-toe.mp3",
  "voeg-meer-rays-in-de-corners": "common/voeg-meer-rays-in-de-corners.mp3",
  "voeg-meer-stralen-in-de-hoeken-toe": "common/voeg-meer-stralen-in-de-hoeken-toe.mp3",
  "voeg-mooie-stippen-toe": "common/voeg-mooie-stippen-toe.mp3",
  "voeg-neus-mond-en-snorharen": "common/voeg-neus-mond-en-snorharen.mp3",
  "voeg-nog-een-rij-regen-toe": "common/voeg-nog-een-rij-regen-toe.mp3",
  "voeg-nog-meer-regen-toe": "common/voeg-nog-meer-regen-toe.mp3",
  "voeg-ogen-en-een-grote-glimlach-toe": "common/voeg-ogen-en-een-grote-glimlach-toe.mp3",
  "voeg-ogen-en-een-grote-smile": "common/voeg-ogen-en-een-grote-smile.mp3",
  "voeg-one-grote-oog-en-een-neusgat": "common/voeg-one-grote-oog-en-een-neusgat.mp3",
  "voeg-raindrops-falling-van-de-clouds": "common/voeg-raindrops-falling-van-de-clouds.mp3",
  "voeg-ramen-met-kleine-ruitjes-toe": "common/voeg-ramen-met-kleine-ruitjes-toe.mp3",
  "voeg-rechte-sunny-rays": "common/voeg-rechte-sunny-rays.mp3",
  "voeg-rechte-zonnestralen-toe": "common/voeg-rechte-zonnestralen-toe.mp3",
  "voeg-regendruppels-toe-die-uit-de-wolken-vallen": "common/voeg-regendruppels-toe-die-uit-de-wolken-vallen.mp3",
  "voeg-schors-lijnen-op-de-stam": "common/voeg-schors-lijnen-op-de-stam.mp3",
  "voeg-schuimende-klauwen-bovenop-toe": "common/voeg-schuimende-klauwen-bovenop-toe.mp3",
  "voeg-shiny-hubcaps-in-de-wielen": "common/voeg-shiny-hubcaps-in-de-wielen.mp3",
  "voeg-sparkles-all-rondom": "common/voeg-sparkles-all-rondom.mp3",
  "voeg-sparkles-rondom-it": "common/voeg-sparkles-rondom-it.mp3",
  "voeg-stekels-op-zijn-back": "common/voeg-stekels-op-zijn-back.mp3",
  "voeg-stekels-op-zijn-rug-toe": "common/voeg-stekels-op-zijn-rug-toe.mp3",
  "voeg-stijgende-bellen-toe": "common/voeg-stijgende-bellen-toe.mp3",
  "voeg-swirly-patterns-op-de-vleugels": "common/voeg-swirly-patterns-op-de-vleugels.mp3",
  "voeg-twee-bolle-wangen-toe": "common/voeg-twee-bolle-wangen-toe.mp3",
  "voeg-twee-grote-ogen": "common/voeg-twee-grote-ogen.mp3",
  "voeg-twee-grote-oog-bobbels-bovenop": "common/voeg-twee-grote-oog-bobbels-bovenop.mp3",
  "voeg-twee-grote-ronde-ogen": "common/voeg-twee-grote-ronde-ogen.mp3",
  "voeg-twee-grote-ronde-oren": "common/voeg-twee-grote-ronde-oren.mp3",
  "voeg-twee-grote-slappe-oren": "common/voeg-twee-grote-slappe-oren.mp3",
  "voeg-twee-grote-wielen": "common/voeg-twee-grote-wielen.mp3",
  "voeg-twee-hoge-oren": "common/voeg-twee-hoge-oren.mp3",
  "voeg-twee-kleine-feelers": "common/voeg-twee-kleine-feelers.mp3",
  "voeg-twee-kleine-feet": "common/voeg-twee-kleine-feet.mp3",
  "voeg-twee-kleine-hoorns": "common/voeg-twee-kleine-hoorns.mp3",
  "voeg-twee-kleine-oren": "common/voeg-twee-kleine-oren.mp3",
  "voeg-twee-kleine-slagtanden-toe": "common/voeg-twee-kleine-slagtanden-toe.mp3",
  "voeg-twee-kleine-tusks": "common/voeg-twee-kleine-tusks.mp3",
  "voeg-twee-kleine-voelsprieten-toe": "common/voeg-twee-kleine-voelsprieten-toe.mp3",
  "voeg-twee-kleine-voetjes-toe": "common/voeg-twee-kleine-voetjes-toe.mp3",
  "voeg-twee-lijnen-down": "common/voeg-twee-lijnen-down.mp3",
  "voeg-twee-lijnen-naar-beneden-toe": "common/voeg-twee-lijnen-naar-beneden-toe.mp3",
  "voeg-twee-lijnen-overdwars": "common/voeg-twee-lijnen-overdwars.mp3",
  "voeg-twee-ogen": "common/voeg-twee-ogen.mp3",
  "voeg-twee-ogen-maak-ze-verschillend": "common/voeg-twee-ogen-maak-ze-verschillend.mp3",
  "voeg-twee-ogen-make-them-different": "common/voeg-twee-ogen-make-them-different.mp3",
  "voeg-twee-ogen-one-ronde-one-van-de-zijde": "common/voeg-twee-ogen-one-ronde-one-van-de-zijde.mp3",
  "voeg-twee-ogen-toe-een-rond-een-van-de-zijkant": "common/voeg-twee-ogen-toe-een-rond-een-van-de-zijkant.mp3",
  "voeg-twee-oren-op-de-zijden": "common/voeg-twee-oren-op-de-zijden.mp3",
  "voeg-twee-piepkleine-neusgaatjes-toe": "common/voeg-twee-piepkleine-neusgaatjes-toe.mp3",
  "voeg-twee-piepkleine-nostrils": "common/voeg-twee-piepkleine-nostrils.mp3",
  "voeg-twee-puffy-wangen": "common/voeg-twee-puffy-wangen.mp3",
  "voeg-twee-puntige-oren": "common/voeg-twee-puntige-oren.mp3",
  "voeg-twee-puntige-oren-bovenop": "common/voeg-twee-puntige-oren-bovenop.mp3",
  "voeg-twee-ramen-toe": "common/voeg-twee-ramen-toe.mp3",
  "voeg-twee-rijen-gebogen-schubben-toe": "common/voeg-twee-rijen-gebogen-schubben-toe.mp3",
  "voeg-twee-ronde-ogen": "common/voeg-twee-ronde-ogen.mp3",
  "voeg-twee-ronde-oren-bovenop": "common/voeg-twee-ronde-oren-bovenop.mp3",
  "voeg-twee-rows-of-gebogen-schubben": "common/voeg-twee-rows-of-gebogen-schubben.mp3",
  "voeg-twee-roze-wangen": "common/voeg-twee-roze-wangen.mp3",
  "voeg-twee-slappe-oren": "common/voeg-twee-slappe-oren.mp3",
  "voeg-twee-windows": "common/voeg-twee-windows.mp3",
  "voeg-vier-benen-that-join-het-lichaam": "common/voeg-vier-benen-that-join-het-lichaam.mp3",
  "voeg-vier-benen-toe-die-aan-het-lichaam-vastzitten": "common/voeg-vier-benen-toe-die-aan-het-lichaam-vastzitten.mp3",
  "voeg-vier-kleine-feet": "common/voeg-vier-kleine-feet.mp3",
  "voeg-vier-kleine-sterren": "common/voeg-vier-kleine-sterren.mp3",
  "voeg-vier-kleine-voetjes-toe": "common/voeg-vier-kleine-voetjes-toe.mp3",
  "voeg-vijf-kleine-sterren": "common/voeg-vijf-kleine-sterren.mp3",
  "voeg-vinnen-bovenop-en-bottom": "common/voeg-vinnen-bovenop-en-bottom.mp3",
  "voeg-vinnen-bovenop-en-onderaan-toe": "common/voeg-vinnen-bovenop-en-onderaan-toe.mp3",
  "voeg-voorpoten-en-pootjes-toe": "common/voeg-voorpoten-en-pootjes-toe.mp3",
  "voeg-wat-grote-raindrops": "common/voeg-wat-grote-raindrops.mp3",
  "voeg-wat-heerlijke-appels": "common/voeg-wat-heerlijke-appels.mp3",
  "voeg-windows-met-kleine-panes": "common/voeg-windows-met-kleine-panes.mp3",
  "voeg-zaadjes-en-gras-toe": "common/voeg-zaadjes-en-gras-toe.mp3",
  "voorlezen-staat-aan": "common/voorlezen-staat-aan.mp3",
  "vul-het-met-een-dambordpatroon": "common/vul-het-met-een-dambordpatroon.mp3",
  "zet-de-ster-op-een-podium-met-een-spotlight": "common/zet-de-ster-op-een-podium-met-een-spotlight.mp3",
  "zwaai-een-grote-golvende-staart": "common/zwaai-een-grote-golvende-staart.mp3"
};

// Per-drawing step clips: drawing id → (slug → repo path).
const BY_DRAWING: Record<string, Record<string, string>> = {};

/**
 * Full CDN URL of the clip for this drawing + spoken phrase, or null if there is
 * none (the caller then uses the browser voice). A drawing-specific clip wins
 * over the shared common one.
 */
export function clipUrlForNL(drawingId: string | undefined, phrase: string): string | null {
  const slug = clipSlug(phrase);
  const path = (drawingId ? BY_DRAWING[drawingId]?.[slug] : undefined) ?? COMMON[slug];
  return path ? `${AUDIO_BASE}/${path}` : null;
}
